import { ChevronLeft, ChevronRight } from "@mui/icons-material"
import { useCallback, useEffect, useState } from "react"
import { BtnPrimary } from "./buttons";
import Proptypes from "prop-types";
import toastr from "toastr"
import { useLocation, useNavigate } from "react-router-dom";

const Pagination = (props)=>{

    const [pageNums,setPageNums] = useState([])
    const navigate = useNavigate();
    const [pageSet,setPageSet] = useState([]);
    const [pageSetNum,setPageSetNum] = useState(0);
    const [pageNum,setPageNum] = useState(0);
    
    const getPageNums = () =>{

        let pageLimit = props.pageSetLimit/5;
        let numOfPages = Math.ceil(pageSet.length/pageLimit);
        let nums = [];

        for(let i=1;i<=numOfPages;i++){
            nums.push(pageSetNum*5+i)

        }

        setPageNums(nums)
        
    }

    const nextPageSet=(e)=>{
        e.preventDefault();
        if(pageSet.length<props.pageSetLimit){
            return toastr.warning('end of data','warning');
        }
        setPageSetNum(prevState=>prevState + 1);
        

    }

    const prevPageSet=(e)=>{
        e.preventDefault();
        setPageSetNum(prevState=>prevState===0?0:prevState - 1);
        
        
    }

    const paginationChangePage=(pageNumber,e)=>{
        // e.preventDefault();
        setPageNum(pageNumber)
       
    
       
    }

    const changeSet = (response)=>{
       
        let pageSetStart = pageSetNum*props.pageSetLimit;
        let nextPageStart = pageSetStart===0?0:pageSetStart+props.pageSetLimit
        if(nextPageStart>=response.length){
       
            props.getNextData(response.length);
            
        }

       
     
        let set = [];
        let count=-1;
        for(let i =pageSetStart; i<=response.length; i++){
            count++
            if(count>=75) break;
            if(response[i]===undefined) continue;
            response[i].srNum = i
            set.push(response[i])
            
            
        }
       //console.log(set)
        setPageSet(set);
        setPageNum(0)
    }

    

    const changePage = ()=>{
        let length = pageSet.length;
        let pageLimit = props.pageSetLimit/5;
        let pageStart = pageNum*pageLimit;
        
        let page = [];
        let count = -1;

        for(let i = pageStart ;i<=length;i++){
            count++
           
            if(count===pageLimit) break;
            if(pageSet[i]===undefined) continue;
            page.push(pageSet[i])
        }
        
        props.setPage(page);
    }

    //page set effects
    useEffect(()=>{
        
           changePage();
           
        
        
    },[pageSet])

    useEffect(()=>{
       
       
            changeSet(props.data);
          
           
        
    },[pageSetNum]);

    //page set effects end


    useEffect(()=>{
        
        changePage();

    },[pageNum])
  
  

    useEffect(()=>{
        getPageNums();

    },[pageSetNum,pageSet.length]);
   
    useEffect(()=>{
        changeSet(props.data)

       

    },[props.data]);

   
    props.pageSetNum(setPageSetNum)


   
    return((props.responseLength<=15)?(<></>):(
        <>
            <div className="pagination-container">
            <BtnPrimary action={prevPageSet} ><ChevronLeft/></BtnPrimary>
            {pageNums.map((e,index)=>{
                return(<BtnPrimary addClass={pageNum===index?"form-btn-2-active":""} action={()=>{paginationChangePage(index)}} key={e}>{e}</BtnPrimary>)
            })}
            <BtnPrimary action={nextPageSet}><ChevronRight/></BtnPrimary>
            </div>
        </>
    )
    )
}

Pagination.propTypes = {
    pageSetControl: Proptypes.func,
    pageControl:Proptypes.func,
    pageSetLimit:Proptypes.number,
    pageNum:Proptypes.number,
    setNumber:Proptypes.number,
    totalEntries:Proptypes.number,
    responseLength:Proptypes.number,

}

export default Pagination;